import React, { useState } from "react";
import { FaTimesCircle } from "react-icons/fa";
import PopUp from "../../components/PopUp";
import { TextField } from "@mui/material";
import { RectBtn } from "../../components/General";
import { createDevice } from "../../apis/Device.Api";
import { addDevice } from "../../features/slices/deviceSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectDevice, selectUserData } from "../../features/store";
import { useSnackbar } from "notistack";

const AddNano = ({ setOpenAddNano, openAddNano }) => {
    const { enqueueSnackbar } = useSnackbar();

    const [nanoId, setNanoId] = useState("");
    const [newNanoError, setNewNanoError] = useState("");
    const userData = useSelector(selectUserData);
    const devices = useSelector(selectDevice);
    const dispatch = useDispatch();
    async function confirmAddNano() {
        setNewNanoError("");
        if (nanoId === "") {
            setNewNanoError("Fields cannot be empty");
            return;
        }
        let nid = "N" + nanoId;
        if (devices[nid]) {
            setNewNanoError("Nano ID must be unique");
            return;
        }

        let dRes = await createDevice({
            device_id: nid,
            room_id: null,
        });
        if (dRes.data.networkError) {
            enqueueSnackbar(dRes.data.message, { variant: "error" });
            return;
        }
        if (!dRes.data.indicator) {
            enqueueSnackbar(`Failed to create nano ${nid}. This is possibly due to duplicated device id.`, {
                variant: "error",
            });
            return;
        }
        dispatch(
            addDevice({
                deviceId: nid,
                roomId: null,
            })
        );
        enqueueSnackbar(`Nano added successfully.`, { variant: "success" });
        setNanoId("");
        setOpenAddNano(false);
    }
    return (
        <PopUp width={45} height={45} switchOn={openAddNano}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Configure Nano</h4>

                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setNewNanoError("");
                            setNanoId("");
                            setOpenAddNano(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="add-nano-wrapper">
                        <TextField
                            placeholder="New Nano ID"
                            onChange={(e) => {
                                if (e.target.value.length < 1) return;
                                if (e.target.value[0] !== "N") {
                                    setNanoId(e.target.value[0] + e.target.value.substring(2));
                                } else {
                                    setNanoId(e.target.value.substring(1));
                                }
                            }}
                            value={"N" + nanoId}
                            inputProps={{ maxLength: 20 }}
                            label="New Nano ID"
                            sx={{ height: "100%" }}
                            error={newNanoError !== ""}
                            helperText={newNanoError}
                        ></TextField>

                        <div className="add-nano-btn-wrapper">
                            <RectBtn onClick={confirmAddNano}> Confirm </RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default AddNano;
